import { render } from "./FlowDescriptionModal.vue?vue&type=template&id=ba01e516"
import script from "./FlowDescriptionModal.vue?vue&type=script&lang=js"
export * from "./FlowDescriptionModal.vue?vue&type=script&lang=js"

import "./FlowDescriptionModal.vue?vue&type=style&index=0&id=ba01e516&lang=css"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__